import { useSelector } from 'react-redux';
import { RootState } from 'redux/root';
import Product from 'static/models/Product';

export const useAvailableProducts = (): Product[] => {
    return useSelector((state: RootState) => state.availableProducts);
};
